import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// API helper
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }
    return Promise.reject(error);
  }
);

// Cities with hotel counts are shared by the homepage, footer and every
// CityCombobox, so they are fetched once per page load. A failed request is
// not cached, letting the next caller retry.
let citiesRequest = null;
export const getCities = () => {
  if (!citiesRequest) {
    citiesRequest = api.get("/hotels/cities")
      .then(res => (Array.isArray(res.data) ? res.data : []))
      .catch(err => { citiesRequest = null; throw err; });
  }
  return citiesRequest;
};
